import leadServiceHandler from "./handlers/leadServiceHandler";


export const handlers = [...leadServiceHandler];
